import { render, staticRenderFns } from "./MeetingEmbed.vue?vue&type=template&id=51c2c6f8&scoped=true&"
import script from "./MeetingEmbed.vue?vue&type=script&lang=js&"
export * from "./MeetingEmbed.vue?vue&type=script&lang=js&"
import style0 from "./MeetingEmbed.vue?vue&type=style&index=0&id=51c2c6f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2c6f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c2c6f8')) {
      api.createRecord('51c2c6f8', component.options)
    } else {
      api.reload('51c2c6f8', component.options)
    }
    module.hot.accept("./MeetingEmbed.vue?vue&type=template&id=51c2c6f8&scoped=true&", function () {
      api.rerender('51c2c6f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/meetings/MeetingEmbed.vue"
export default component.exports